import React from "react";

const Footer = () => {
  return <div className="py-4 text-center bg-primary text-white "> &copy; 2023 Pranjal Sharma.  All Rights Reserved.</div>;
};

export default Footer;
